import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiURL: 'https://api.hartmanyacht.com/api',
    serverPath: 'https://api.hartmanyacht.com',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
